import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import { PRODUCT_SELECTION_STAGE } from "_constants/GlobalConstants";
import MCSHeader from "components/MCSHeader";
import MCSSpace from "components/MCSSpace";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import StoreWizard from "./Components/StoreWizard";
import StoreOrderForm from "./StoreOrderForm";

const Store = () => {
  //This will be used to manage the current step for 3DS Store
  const [progressState, setProgressState] = useState([
    {
      active: true,
      completed: false,
      error: false,
      label: "1",
      title: "Choose Product",
      tooltip: false,
    },
    {
      active: false,
      completed: false,
      error: false,
      label: "2",
      title: "Select Details",
      tooltip: false,
    },
    {
      active: false,
      completed: false,
      error: false,
      label: "3",
      title: "Order Review",
      tooltip: false,
    },
    {
      active: false,
      completed: false,
      error: false,
      label: "4",
      title: "Place Order",
      tooltip: false,
    },
  ]);

  // Initialize default values for StoreOrderForm
  const location = useLocation();
  const defaultSelectedCategory = location.state && location.state.selectedProduct ? location.state.selectedProduct : 0;
  const [progressStep, setProgressStep] = useState(PRODUCT_SELECTION_STAGE);

  const handleStepUpdate = (nextStepNumber) => {
    const steps = progressState.map((step) => ({
      ...step,
      active: parseInt(step.label) === nextStepNumber,
      completed:
        parseInt(step.label) < nextStepNumber ||
        (parseInt(step.label) == 4 && nextStepNumber == 4),
    }));
    setProgressStep(nextStepNumber);
    setProgressState(steps);
  };

  return (
    <Grid>
      <MCSHeader header="VSS Store" />
      <Row>
        <Col>
          <StoreWizard progressState={progressState} />
        </Col>
      </Row>
      <MCSSpace height="30px" />
      <Row>
        <Col>
          <StoreOrderForm
            defaultSelectedCategory={defaultSelectedCategory}
            progressStep={progressStep}
            handleStepUpdate={handleStepUpdate}
          />
        </Col>
      </Row>
    </Grid>
  );
};

export default Store;
